import { HeaderPanel } from '../HeaderPanel';
import { InstrumentListsPanelContent } from './components/InstrumentListsPanelContent';

import styles from './InstrumentListsPanel.module.scss';

type Props = { expanded: boolean; onClose: () => void };

export const InstrumentListsPanel: React.FC<Props> = ({ expanded, onClose }) => {
  return (
    <div className={styles.panelContainer}>
      <HeaderPanel expanded={expanded} onClose={onClose} title={'menu.instrumentLists'} />
      {expanded && <InstrumentListsPanelContent />}
    </div>
  );
};
